<template>
  <div
    class="icon-container"
    :class="{
      'disabled': disabled,
      'loading': loading,
      'unfollowed': unfollowed && !subscriptionName,
      'unfollowed-person': unfollowed && subscriptionName,
    }"
  >
    <span
      v-if="subscriptionName && unfollowed"
      class="subscriber-name"
    >
      {{ subscriptionLabel }}
    </span>
    <cs-icon
      v-else
      :name="iconName"
      :color="colorImage"
      container-size="extra-medium"
    />
  </div>
</template>

<script>
const ICONS_LIST = [
  'bear',
  'bull',
  'elk',
  'fish',
  'hare',
  'owl',
  'raccoon',
  'sheep',
  'squirrel',
  'wolf',
];

export default {
  name: 'SubscriptionIcon',
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    unfollowed: {
      type: Boolean,
      default() {
        return false;
      },
    },
    subscriptionName: {
      type: String,
      default() {
        return '';
      },
    },
    colorImage: {
      type: String,
      default() {
        return '#fff';
      },
    },
  },
  created() {
    this.iconName = ICONS_LIST[Math.floor(Math.random() * 10)];
  },
  data() {
    return {
      iconName: null,
    };
  },
  computed: {
    subscriptionLabel() {
      if (this.$validate.isNull(this.subscriptionName)) {
        return '';
      }

      return this.subscriptionName.slice(0, 1).toUpperCase();
    },
  },
};
</script>

<style lang="sass" scoped>
  .icon-container
    width: 40px
    height: 40px
    flex: none
    display: flex
    align-items: center
    justify-content: center
    background: linear-gradient(249.76deg, rgba(91, 204, 126, 0.7) -8.32%, rgba(123, 211, 255, 0.7) 108.85%), rgba(255, 255, 255, 0.5)
    border-radius: 50%

    &.unfollowed
      background: #FF5172

    &.unfollowed-person
      background: linear-gradient(68.79deg, rgba(255, 107, 140, 0.7) 0%, rgba(254, 143, 122, 0.7) 100%), rgba(255, 255, 255, 0.5)

    &.loading
      #{theme("eclipse")} &
        background: linear-gradient(270deg, rgba(33, 33, 33, 0.25) 0%, rgba(0, 0, 0, 0) 100%)

      #{theme("obsidian")} &
        background: #FFFFFF
        opacity: 0.2

    &.disabled
      opacity: 0.5

      #{theme("eclipse")} &
        background: rgba(33, 33, 33, 0.15)

      #{theme("obsidian")} &
        background: linear-gradient(0deg, #40404F, #40404F), rgba(255, 255, 255, 0.5)

  .subscriber-name
    width: 24px
    height: 24px
    text-align: center
    font-weight: 600
    font-size: 14px
    line-height: 146.28%
</style>
